import { render, staticRenderFns } from "./ListModels.vue?vue&type=template&id=3b9d367c&scoped=true&"
import script from "./ListModels.vue?vue&type=script&lang=js&"
export * from "./ListModels.vue?vue&type=script&lang=js&"
import style0 from "./ListModels.vue?vue&type=style&index=0&id=3b9d367c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d367c",
  null
  
)

export default component.exports